import { Link } from 'react-router-dom';
import { heroArticles } from '@/mocks/homeData';

export default function HeroSection() {
  return (
    <section className="relative pt-24 pb-12 md:pt-32 md:pb-16 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="flex justify-center mb-8 md:mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-accent-100 text-accent-800 text-sm">
            <i className="ri-notification-3-line"></i>
            <span className="whitespace-nowrap">实时追踪 · 每日更新 · 不打烊</span>
            <button
              type="button"
              className="w-6 h-6 flex items-center justify-center rounded-full bg-accent-200 hover:bg-accent-300 transition-colors cursor-pointer"
              aria-label="订阅"
            >
              <i className="ri-add-line text-xs"></i>
            </button>
          </div>
        </div>

        <div className="text-center max-w-4xl mx-auto mb-10 md:mb-14">
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-foreground-950 leading-tight">
            吃瓜黑料网
            <br />
            黑料不停更
          </h1>
          <p className="mt-5 md:mt-6 text-base md:text-lg text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            每日更新网红黑料、明星塌房、热门事件，提供在线爆料与视频
            <br />
            实时追踪每日大赛，吃瓜不打烊
          </p>
          <div className="flex items-center justify-center gap-3 mt-7 md:mt-8">
            <Link
              to="/category/wanghong"
              className="px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              最新爆料
            </Link>
            <Link
              to="/category/video"
              className="px-6 py-3 rounded-full bg-background-50 text-foreground-800 text-sm font-medium border border-foreground-200 hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              吃瓜视频
            </Link>
          </div>
        </div>

        <div className="rounded-3xl overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20dark%20dramatic%20composition%20with%20flowing%20ink%20shapes%2C%20warm%20deep%20brown%20and%20amber%20tones%2C%20mysterious%20atmosphere%2C%20elegant%20artistic%20texture%2C%20cinematic%20lighting%2C%20high%20contrast%2C%20sophisticated%20editorial%20design%2C%20dark%20background%20with%20golden%20accents%2C%20modern%20minimalist%20aesthetic&width=1600&height=700&seq=hero-banner-main&orientation=landscape"
            alt="吃瓜黑料网 - 热门爆料头条"
            title="吃瓜黑料网 - 吃瓜黑料在线爆料与视频"
            className="w-full h-[300px] md:h-[500px] object-cover object-top"
          />
        </div>
      </div>
    </section>
  );
}